import React from 'react';
import { Chart, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { DARK_BASE, TEAL } from './constants';
import ChartCard from './ChartCard';
import { useChartTheme } from './useChartTheme';

Chart.register(Tooltip, Legend, BarElement, LinearScale, CategoryScale);

interface AttackClassChartProps {
  /** Map of attack class name → count, pre-sorted descending */
  data: [string, number][];
  height?: number;
}

const AttackClassChart: React.FC<AttackClassChartProps> = ({ data, height = 280 }) => {
  const { textColor, isDark } = useChartTheme();

  const chartData = {
    labels: data.map(([k]) => k),
    datasets: [
      {
        backgroundColor: isDark ? TEAL : DARK_BASE,
        hoverBackgroundColor: isDark ? 'rgba(5,255,224,0.6)' : TEAL,
        data: data.map(([, v]) => v),
        borderRadius: 2,
        barThickness: 32,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    plugins: { legend: { display: false } },
    scales: {
      x: { grid: { display: false }, ticks: { color: textColor, font: { size: 11 } } },
      y: { grid: { display: false }, ticks: { color: textColor, font: { size: 11 } } },
    },
    responsive: true,
    maintainAspectRatio: false,
  } as any;

  return (
    <ChartCard title="Attack class" sub="Findings by attack category">
      {data.length > 0 ? (
        <div style={{ height }}>
          <Bar data={chartData} options={options} />
        </div>
      ) : (
        <div className="text-muted text-center py-5 small">No data</div>
      )}
    </ChartCard>
  );
};

export default AttackClassChart;
